/**
 * =============================================================================
 * setera-web
 * =============================================================================
 * Copyright (c) 2026 HG Digital/Setera
 * Todos os direitos reservados.
 *
 * Este software é confidencial e de propriedade da HG Digital/Setera.
 * Seu uso está sujeito aos termos do contrato de licença.
 * -----
 * Criado em : 20-08-2026 16:57:03
 * Autor     : Diego Brock
 * Projeto   : setera-web
 * Versão    : 1.0.0
 * =============================================================================
 */

/** Resultado da partição de terminais por gateway. */
export interface GatewayTerminalPartition {
  /** Terminais da nova arquitetura (`gatewayModel === 'T'`). */
  modern: any[];
  /** Terminais legados (`gatewayModel !== 'T'`). */
  legacy: any[];
}

/**
 * Normaliza `gatewayModel` / `gateway_model` em cada item da seleção.
 *
 * @param terminals lista retornada pelo mapa / posição atual
 */
export function normalizeGatewayModels(terminals: any[]): any[] {
  if (!Array.isArray(terminals)) {
    return [];
  }
  return terminals.map((item) => {
    if (!item) {
      return item;
    }
    const gatewayModel = item.gatewayModel != null
      ? item.gatewayModel
      : item.gateway_model;
    if (gatewayModel != null) {
      item.gatewayModel = gatewayModel;
    }
    return item;
  });
}

/**
 * Indica se o terminal pertence à nova arquitetura de comandos.
 *
 * @param terminal item da seleção
 */
export function isModernGatewayTerminal(terminal: any): boolean {
  return !!terminal && terminal.gatewayModel === 'T';
}

/**
 * Particiona a seleção em modern (`T`) e legacy (demais / ausente).
 *
 * @param terminals seleção do mapa
 */
export function partitionTerminalsByGateway(terminals: any[]): GatewayTerminalPartition {
  const normalized = normalizeGatewayModels(terminals);
  const modern: any[] = [];
  const legacy: any[] = [];
  normalized.forEach((item) => {
    if (isModernGatewayTerminal(item)) {
      modern.push(item);
    } else if (item) {
      legacy.push(item);
    }
  });
  return { modern, legacy };
}
